import AppListing from '../app-components/Listing/AppListing';

Vue.component('attendance-listing', {
    mixins: [AppListing],
    data() {
        return {
            loadingData: true,
            ajaxError: false,
            countTableRows: 0,
            gridData: [],
            mutableUrl: '',
            dateUrlPath: '',
            selectedMonthMutable: {},
            selectedStatusMutable: {},
            selectedContractTypeMutable: {},
            initSetDataComplete: false,
            sendingExport: false,
            exportSuccess: false,
            loading: false,
            startOfMonth: '',
            endOfMonth: '',
            filters: {
                status: 'all',
                contractType: 'all'
            },
            orderBy: {
                column: 'employee_full_name',
                direction: 'asc'
            },
            evtCreatedFired: false,
            year: null,
            month: null
        };
    },

    props: {
        'baseUrl': {
            type: String
        },
        'baseGridUrl': {
            type: String
        },
        'transMonths': {
            type: Object
        },
        'selectedMonth': {
            type: Object,
            default() {
                return null;
            }
        },
        'selectedStatus': {
            type: Object,
            default() {
                return null;
            }
        },
        'avalaibleStatuses': {
            type: Array,
            default() {
                return [];
            }
        },
        'selectedContractType': {
            type: Object,
            default() {
                return null;
            }
        },
        'avalaibleContractTypes': {
            type: Array,
            default() {
                return [];
            }
        },
        'sendingMrp': {
            type: Boolean,
            default: false
        }
    },

    created() {
        this.evtCreatedFired = true;
        this.countTableRows = $(".table thead tr th").length;

        if (this.data != null) {
            this.populateCurrentStateAndData(this.data);
        }

        this.year = Number( moment(this.selectedMonth.key).format('YYYY') );
        this.month = Number( moment(this.selectedMonth.key).format('MM') );

        this.selectedMonthMutable = this.selectedMonth.key;
        this.selectedStatusMutable = this.selectedStatus;
        this.selectedContractTypeMutable = this.selectedContractType;

        this.startOfMonth =  moment(this.selectedMonthMutable, "YYYY-MM").startOf('month').format("YYYY-MM-01 00:00:00");
        this.endOfMonth =  moment(this.selectedMonthMutable, "YYYY-MM").endOf('month').format("YYYY-MM-DD 23:59:59");

        this.dateUrlPath = moment(this.selectedMonthMutable, "YYYY-MM").format("YYYY/MM");

        this.mutableUrl = this.url;

        this.$nextTick(function () {
            this.initSetDataComplete = true;
            // this.refreshData();
        });

        this.loadData();
    },

    methods: {
        chooseMonth(year, month) {
            this.selectedMonthMutable = year+"-"+(month < 10 ? "0":"")+month;

            this.year = year;
            this.month = month;

            const momentDate = moment(this.selectedMonthMutable, "YYYY-MM");

            this.dateUrlPath = momentDate.format("YYYY/MM");
            this.startOfMonth = momentDate.startOf('month').format("YYYY-MM-01 00:00:00");
            this.endOfMonth =  momentDate.endOf('month').format("YYYY-MM-DD 23:59:59");

            this.mutableUrl = this.baseUrl+"/"+this.dateUrlPath;

            this.refreshData();
        },

        getFilterableUrl(withoutBase) {
            let qsParams = [];

            if(this.filters.status && this.filters.status != 'all' ) {
                qsParams.push("status="+this.filters.status);
            }

            if(this.filters.contractType) {
                qsParams.push("contractType="+this.filters.contractType);
            }

            return (withoutBase ? '' : this.mutableUrl) + (qsParams.length>0 ? '?'+qsParams.join("&") : '');
        },

        setStatus() {
            let val = this.filters.status;
            if(!val) val = 'all';
            this.selectedStatusMutable = this.avalaibleStatuses.find(x => x.key == val);
        },

        setContractType(contractTypeId) {
            let val = this.filters.contractType;
            if(!val) val = 'all';
            this.selectedContractTypeMutable = this.avalaibleContractTypes.find(x => x.key == val);
        },

        refreshData() {
            if(this.initSetDataComplete && !this.loadingData) {

                if(window.history.replaceState) {

                    window.history.replaceState({}, null, this.getFilterableUrl());
                }

                this.loadData();
            }
        },

        // override from BaseListing
        loadData: function loadData()
        {
            // prevent load from created() of craftable BaseListing parent class (we call it after initialization in local created() method)
            if(!this.evtCreatedFired)
            {
                return;
            }

            var _this = this;

            var options = {
                params: {
                    orderBy: this.orderBy.column,
                    orderDirection: this.orderBy.direction
                }
            };

            Object.assign(options.params, this.filters);

            _this.loadingData = true;
            _this.ajaxError = false;

            let gridUrl = this.baseGridUrl+"/"+this.dateUrlPath;

            axios.get(gridUrl, options).then(function (response) {
                _this.gridData = response.data;
                _this.loadingData = false;

                //return _this.populateCurrentStateAndData(response.data.data);
            }, function (error) {
                _this.loadingData = false;
                _this.ajaxError = true;
            });
        },

        mexportOpenDialog()
        {
            this.$modal.show('mexport-modal-form');
        },

        getDynamicAdditionValue(item, type)
        {
            let daObj = item.dynamic_additions[type];

            if(daObj)
            {
                let value = parseFloat(item.dynamic_additions[type]["monthly_value"]);
                if(value!="NaN")
                {
                    return value.toFixed(2);
                }
            }
            return "";
        },

        resetFilter() {
            this.filters.status='all';
            this.filters.contractType='all';
            this.search='';
        },

        isFiltered() {
            if(this.filters.status != 'all' || this.filters.contractType != 'all' || this.search != '')
            {
                return 1;
            }
            else
            {
                return 0;
            }
        },

        getDynamicFieldValue(item, id)
        {
            let daObj = item.dynamic_fields[id];

            if(daObj)
            {
                let value = item.dynamic_fields[id]["value"];
                if(value!="NaN")
                {
                    return value;
                }
            }
            return "";
        },

        gridColumnsSetting() {
            this.$modal.show('attendance-grid-columns');
        },

        addDecimalsByNumber(number)
        {
            if((number+"").match(/^[\-0-9]+\.[0-9]+$/))
            {
                return parseFloat(number).toFixed(2);
            }

            return number;
        },

        downloadWithLoader(route) {
            return route.replace('--year--', this.year)
                        .replace('--month--', this.month);
        }
    },

    watch: {
        selectedStatusMutable: function(newVal, oldVal) {
            if(newVal.key != oldVal.key) {
                this.filters.status = newVal.key;
                this.refreshData();
            }
        },

        selectedContractTypeMutable: function(newVal, oldVal) {
            if(newVal.key != oldVal.key) {
                this.filters.contractType = newVal.key;
                this.refreshData();
            }
        }
    }

});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/attendance/Listing.js